export const MSG_LOADING = "ກຳລລັງໂຫຼດຂໍ້ມູນ";
export const MSG_INCOMPLETE_DATA = "ຂໍ້ມູນບໍ່ຄົບຖ້ວນ!";
export const MSG_INVALID_AMOUNT_OR_VOLUME = "ພົບວ່າ ຈຳນວນຫລືບໍລິມາດບໍ່ຖືກຕ້ອງ!";
export const MSG_SUCCESS = "ດືງຂໍ້ມູນສຳເລັດ";
export const MSG_CREATE_SUCCESS = "ສ້າງສຳເລັດ";
export const MSG_CREATE_FAIL = "ສ້າງບໍ່ສຳເລັດ";
export const MSG_UPDATE_SUCCESS = "ແກ້ໄຂສຳເລັດ";
export const MSG_DELETE_SUCCESS = "ລຶບສຳເລັດ";
export const MSG_ERROR = "ຂໍ້ຜິດພາດ";
export const MSG_INTERNAL_ERROR = "ບໍ່ສຳເລັດ ພົບຂໍ້ຜີດຜາດທີ່ບໍ່ຄາດຄີດ";
export const MSG_SHOP_UNAVAILABLE = "ບໍ່ພົບຂໍ້ມູນຮ້ານ ກະລຸນາລ໊ອກອີນໃຫມ່";


export const MSG_DATA_NOT_FOUND = "ບໍ່ມີຂໍ້ມູນ";